import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import myaxios from './axios'; //axios的全局配置
import Vant from 'vant'
import 'vant/lib/index.css';
import '@/styles/global.scss'; //全局响应式样式规范
import { initResponsive } from '@/utils/responsive'; //桌面/移动断点判定
import { Dialog } from 'vant';
import { Toast } from 'vant';
import VueMeta from 'vue-meta';
Vue.use(Vant)
Vue.use(Dialog);
Vue.use(Toast);
Vue.config.productionTip = false

// 初始化屏幕断点监听：桌面端与手机端共用同一套组件，按窗口宽度切换形态
initResponsive();

// 给全局Vue实例对象添加axios属性
Vue.prototype.$axios = myaxios;

Vue.use(VueMeta);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
